import { useState } from "react";
import styles from "./CrossBar.module.css";

function CrossBar({ fyk, input, onChange }) {
  const [stirrupLegs, setStirrupLegs] = useState(2);
  const [stirrupDiameter, setStirrupDiameter] = useState(6.3);
  const [stirrupSpacing, setStirrupSpacing] = useState("");
  const [stirrupArea, setStirrupArea] = useState(0);

  function getAs(legs, diameter, spacing) {
    if (spacing === "") {
      const as = 0;
      setStirrupArea(as);
    } else {
      const count = 100 / spacing;
      const as = legs * count * ((Math.PI * (diameter / 10) ** 2) / 4);
      setStirrupArea(as);
    }
    if (onChange) onChange(input, as);
  }

  return (
    <form className={styles.component}>
      <div className={styles.componentRow}>
        <select
          className={styles.componentElements}
          onChange={(ev) => {
            setStirrupLegs(ev.target.value);
            getAs(ev.target.value, stirrupDiameter, stirrupSpacing);
          }}
          value={stirrupLegs}
        >
          {[2, 4, 6].map((element, i) => (
            <option key={i} value={element}>
              {element}
            </option>
          ))}
        </select>
        <label className={styles.componentText}>ramos Ø</label>
        <select
          className={styles.componentElements}
          onChange={(ev) => {
            setStirrupDiameter(ev.target.value);
            getAs(stirrupLegs, ev.target.value, stirrupSpacing);
          }}
          value={stirrupDiameter}
        >
          {fyk === 500
            ? [6.3, 8, 10, 12.5, 16, 20, 25, 32].map((element, i) => (
                <option key={i} value={element}>
                  {element}
                </option>
              ))
            : [5].map((element, i) => (
                <option key={i} value={element}>
                  {element}
                </option>
              ))}
        </select>
        <label className={styles.componentText}>{"c/"}</label>
        <input
          className={styles.componentInput}
          onKeyPress={(event) => {
            if (!/[0-9]/.test(event.key) || barCount.length >= 2) {
              event.preventDefault();
            }
          }}
          onChange={(ev) => {
            setStirrupSpacing(ev.target.value);
            getAs(stirrupLegs, stirrupDiameter, ev.target.value);
          }}
          value={stirrupSpacing}
        ></input>
        <label className={styles.componentText}>{"cm"}</label>
      </div>
      <div className={styles.componentRow}>
        <label className={styles.componentTextSpacing}>
          {"(" + "Asw,adot" + "=" + stirrupArea.toFixed(2) + " cm²/m" + ")"}
        </label>
      </div>
    </form>
  );
}

export default CrossBar;
